import Box from '@mui/system/Box';
import { TaskStatus } from '../generated/graphql';
import { TaskStatusTypeLabelArray } from '../types';
import { Chip } from '@mui/material';

export function TaskStatusChip(props: { status: TaskStatus; size?: 'small' | 'medium' }) {
  const { status, size } = props;
  const statusInfo = TaskStatusTypeLabelArray.find((s) => s.value === status);

  if (!statusInfo) {
    return null;
  }

  return <Chip label={statusInfo.label} color={statusInfo.color} size={size} />;
}
